<template>
  <section class="testimonials-section">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <i class="fas fa-arrow-right"></i>
          <span>{{ content.header.tag }}</span>
        </div>
        <h2>{{ content.header.title }}</h2>
      </div>
      
      <div class="testimonials-slider swiper" ref="testimonialsSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(testimonial, index) in content.testimonials" :key="index">
            <div class="testimonial-card">
              <div class="quote-symbol">"</div>
              <div class="testimonial-content">
                <p>"{{ testimonial.quote }}"</p>
                <div class="client-info">
                  <img :src="testimonial.client.image" :alt="testimonial.client.name" class="client-image" />
                  <div class="client-details">
                    <h4>{{ testimonial.client.name }}</h4>
                    <span>{{ testimonial.client.position }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <div class="swiper-pagination testimonials-pagination"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
  name: 'AIMLItsTestimonialComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  setup() {
    const testimonialsSwiper = ref(null)

    onMounted(() => {
      initTestimonialsSwiper()
    })

    const initTestimonialsSwiper = () => {
      setTimeout(() => {
        const checkSwiper = () => {
          if (window.Swiper) {
            testimonialsSwiper.value = new window.Swiper('.testimonials-slider', {
              loop: true,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              pagination: {
                el: '.testimonials-pagination',
                clickable: true,
              },
              breakpoints: {
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                }
              }
            });
          } else {
            setTimeout(checkSwiper, 100);
          }
        };
        checkSwiper();
      }, 500);
    }

    return {
      testimonialsSwiper
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Client Testimonials Section */
.testimonials-section {
  padding: 100px 0;
  background: linear-gradient(145deg, #0a0f1c, #1a2332);
  color: #fff;
}

.testimonials-section .section-header {
  text-align: center;
  margin-bottom: 80px;
}

.testimonials-section .section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(251, 14, 118, 0.1);
  border: 1px solid rgba(251, 14, 118, 0.3);
  padding: 8px 20px;
  border-radius: 25px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #FB0E76;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.testimonials-section .section-tag i {
  font-size: 12px;
  color: #FB0E76;
}

.testimonials-section .section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  line-height: 1.2;
}

.testimonials-slider {
  position: relative;
  padding: 0 20px;
}

.testimonial-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 20px;
  padding: 40px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.testimonial-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(246, 236, 79, 0.3);
}

.quote-symbol {
  position: absolute;
  top: -15px;
  left: 33px;
  font-size: 60px;
  color: #FB0E76;
  opacity: 0.8;
  font-weight: 700;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.testimonial-content {
  position: relative;
  z-index: 2;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.testimonial-content p {
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 30px;
  flex: 1;
}

.client-info {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: auto;
}

.client-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.client-details h4 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 5px 0;
}

.client-details span {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

/* Testimonials Pagination */
.testimonials-pagination {
  position: relative;
  margin-top: 40px;
  text-align: center;
}

.testimonials-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: rgba(255, 255, 255, 0.3);
  opacity: 1;
  margin: 0 5px;
  transition: all 0.3s ease;
}

.testimonials-pagination .swiper-pagination-bullet-active {
  background: #FB0E76;
  transform: scale(1.2);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .testimonials-section {
    padding: 80px 0;
  }
  
  .section-header h2 {
    font-size: 36px;
  }
}

@media only screen and (max-width: 767px) {
  .section-header h2 {
    font-size: 28px;
  }
  
  .section-tag {
    font-size: 12px;
    padding: 6px 16px;
  }
  
  .testimonial-card {
    padding: 30px 20px;
  }
  
  .quote-symbol {
    font-size: 60px;
    top: -15px;
    left: -15px;
  }
}
</style>
